import React, { useContext, useState } from "react";
import { DataTable, Table } from "@sscs/ui";
import { getQueryStatus } from "@sscs/utils";
import { REPORT_PAGES_ROUTES } from "../../../../constants";
import { filteredByUri } from "../../../../store/networkingSlice";
import { expandedRowPaginationUpdated, selectExpandedRowPagination, } from "../../../../store/saasbomSlice";
import { LinkToReportTab, NetworkingUrlValue, PolicyAudit, } from "../../../common";
import { ReportContext } from "../../../context";
import { useReportDispatch, useReportSelector } from "../../../hooks";
import { useGetServiceDetailsQuery } from "../../../services/saasbom.api";
import styles from "./serviceDetails.module.scss";
const EndpointItem = ({ endpoint, focused, onClick, linkId, }) => {
    const dispatch = useReportDispatch();
    const tableCells = (React.createElement(React.Fragment, null,
        React.createElement(Table.Cell, null,
            React.createElement(NetworkingUrlValue, { value: endpoint.endpoint, classification: endpoint.classification.classification })),
        React.createElement(Table.Cell, null,
            React.createElement(LinkToReportTab, { id: linkId, to: REPORT_PAGES_ROUTES.NETWORKING_ROUTE, color: "link", className: styles["action-link"], onClick: () => dispatch(filteredByUri({
                    id: endpoint.id,
                    value: endpoint.endpoint,
                })) }, "View in networking"))));
    const hasAudit = endpoint.audit.present;
    return (React.createElement(DataTable.ExpandedRow, { disabled: !hasAudit, focused: focused, onClick: onClick },
        React.createElement(DataTable.ExpandedRow.Summary, null, tableCells),
        hasAudit && (React.createElement(DataTable.ExpandedRow.Details, { className: styles["endpoint-details"] },
            React.createElement(PolicyAudit, { audit: endpoint.audit })))));
};
const COLUMNS = [
    { id: "audit", label: "Audit", width: "80px" },
    { id: "endpoint", label: "Endpoint", width: "100%" },
    { id: "action", label: "Action", width: "175px" },
];
const EndpointList = ({ serviceId, endpointCount, rowIndex, }) => {
    const dispatch = useReportDispatch();
    const { reportId } = useContext(ReportContext);
    const [focused, setFocused] = useState(null);
    const pagination = useReportSelector((state) => selectExpandedRowPagination(state, serviceId));
    const { data = { match_count: 0, endpoints: [] }, isLoading, isFetching, isError, error, } = useGetServiceDetailsQuery({
        ui_id: reportId,
        ui_item_id: serviceId,
        pagination,
    });
    return (React.createElement(DataTable, { title: "Endpoints", columns: COLUMNS, pagination: {
            id: `endpoint-pagination-${rowIndex}`,
            itemCount: endpointCount,
            pagination,
            onChange: (pagination) => dispatch(expandedRowPaginationUpdated({ pagination, id: serviceId })),
        }, status: getQueryStatus({ isLoading, isFetching, isError, error, data }) }, data.endpoints.map((endpoint, index) => (React.createElement(EndpointItem, { key: endpoint.id, endpoint: endpoint, focused: focused === endpoint.id, onClick: () => setFocused(endpoint.id), linkId: `networking-link-row-${rowIndex}-${index}` })))));
};
export default EndpointList;
//# sourceMappingURL=EndpointList.js.map